import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, branch, renderComponent, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import History from '@material-ui/icons/History';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import {
  learnerVersionsRequest,
  printReportRequest,
  resetLearnerVersion,
  resetPathToSaveVersion,
} from '../redux/reducers/savedVersions';
import { selectUserVersion, setUserRatingVersion,setUserRating, setUserRatingComment, setRatingDone, selectUserContent, selectUserModule } from '../redux/reducers/userProgramsFull';
import * as moment from 'moment';

import Spinner from './Spinner';
import { commonStyles } from '../styles/styles';
import iconPrint from '../assets/icon_print.svg';
import { convertTime } from '../utils';
import IframePopup from './Popups/IframePopup';
import {versionStatusRequest,setVersionStatus} from '../redux/reducers/versionStatus'

import {getVersions, selectedProgramId, selectedContentId, selectedModuleId, getVersionsStatus} from '../redux/selectors'

import {
  userRatingsRequest
} from '../redux/reducers/userRatings';

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBadge} from "mdbreact";
import UserRatingPopup from './Popups/UserRatingPopup';
import ModalPopup from './Popups/ModalPopup';
import { xapiRequest } from '../redux/reducers/xapi';
import CoachRatingPopup from './Popups/CoachRatingPopup';
import { showMessageCenter } from '../redux/reducers/messagesList';
import { setRemoveId, showRemoveModal } from '../redux/reducers/view';
import RemoveVersion from './Popups/RemoveVersion';



const LearnerVersions = ({
  classes,
  savedVersions,
  handlePrint,
  handleClickVersion,
  handleBack,
  handlePopupToggle,
  isShowPopup,
  isShowSubmit,
  handleSubmitPopupToggle2,
  handleSubmitPopupToggle,
  handleClickSubmit,
  setUserRatingComment,
  handleNewInstance,
  handleShowComment,
  versions,
  showComment,
  handleHideComment,
  comment,
  showBlock,
  handle,
  coachComment,
  versionStatus,
  showCommentCoach,
  handleShowCommentCoach, 
  handleRemove,
  view
}) => {

  const getButtonAction = (action, item) => {
    var btn = null
    switch (action) {
      case 'draft':
        btn = <div><MDBBtn className="table-btn noShadow" size="sm" color="warning"  onClick={() => handleClickVersion(item.path, item.versionId)}>RESTORE</MDBBtn><MDBBtn className="table-btn noShadow text-light" size="sm" color="danger"  onClick={() => handleRemove(item.versionId)}>REMOVE</MDBBtn></div>
        break;
      case 'reviewed':
        btn = <div><MDBBtn className="table-btn noShadow" size="sm" color="success"  onClick={() => handleClickVersion(item.path, item.versionId)}>VIEW</MDBBtn></div>
        break;
      case 'pending':
        btn = <div><MDBBtn className="table-btn noShadow" size="sm" color="danger-dark">PENDING</MDBBtn></div>
        break;
      case 'completed':
        btn = <div><MDBBtn className="table-btn noShadow" size="sm" color="info"  onClick={() => handleSubmitPopupToggle2(item)}>SUBMIT FOR REVIEW</MDBBtn><MDBBtn className="table-btn noShadow text-light" size="sm" color="danger"  onClick={() => handleRemove(item.versionId)}>REMOVE</MDBBtn></div>
        break;
      default:
        btn = <MDBBtn>Test</MDBBtn>
        break;
    }
      // if(content.type!=='Assignments'){
      //   return false;
      // }else{
        return btn;
      //}
     
    };

    const getStatus = action => {
      var btn = null
      switch (action) {
        case 'draft':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="warning-light">DRAFT</MDBBadge>
          break;
        case 'reviewed':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="success-light">REVIEWED</MDBBadge>
          break;
        case 'pending':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="danger-light">PENDING</MDBBadge>
          break;
        case 'completed':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="info-light">COMPLETED</MDBBadge>
          break;
        default:
          btn = <MDBBadge>Test</MDBBadge>
          break;
      }
        // if(content.type!=='Assignments'){
        //   return false;
        // }else{
          return btn;
        //}
       
      };
  if (versions) {
    const renderVersions = (item) => {
      
      return (
        <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
          <MDBCol className="table-col pl-2 leftAlign"><p>{item.name}</p></MDBCol>
          <MDBCol className="table-col">{item.rating ?  <div className="xs-copy-ptsans"><p>
            <MDBBadge style={{position:'static',marginRight: 5, cursor:'pointer'}} className="badge-lg-pill-round danger-color-border noShadow"  color="danger-color" onClick={()=>handleShowComment(item.comment)}>{item.rating}</MDBBadge></p></div> 
            : 
            <p>'N/A'</p>}</MDBCol>
            <MDBCol className="table-col">{item.quality_rating ?  <div className="xs-copy-ptsans"><p>
            <MDBBadge style={{position:'static',marginRight: 5, cursor:'pointer'}} className="badge-lg-pill-round"  color="grey-color" onClick={()=>handleShowCommentCoach(item)}>{item.quality_rating}</MDBBadge>
            </p></div> : <p>'N/A'</p>}</MDBCol>
          <MDBCol className="table-col"><p><MDBIcon className="pr-2" far icon="calendar" />{moment(item.updated_at.date).format('DD/MM/YYYY')}</p></MDBCol>
          <MDBCol className="table-col"> 
            <p>
            <div className="mailBadge m-0" onClick={()=>this.props.showMessageCenter(true)}>
              <MDBIcon style={{fontSize: '1.3rem', color: '#13a2d9'}} far icon="envelope" className="ml-1" size="lg" />
              <MDBBadge className="badge-white badge-sm-pill-round">{item.numberOfUnreadMessages}</MDBBadge>
            </div>
            </p>
          </MDBCol>
          <MDBCol className="table-col"><p>{getStatus(item.status)}</p></MDBCol>
          <MDBCol className="col-2 table-col pr-2 no-border"><p>{getButtonAction(item.status, item)} </p></MDBCol>
          </MDBRow>
      );
      };
      const renderVersionsMedium = (item) => {
      
        return (
         <MDBCard>
            <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
              <MDBCol className="table-col pl-2">
                <div className="pt-2 pb-2">
                  <b>{item.name}</b>
                </div>
                <div  style={{display:'inline-block'}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.updated_at.date).format('DD/MM/YYYY')}
                </div>
                <div style={{display:'inline-block', paddingLeft:10}}>
                  {getStatus(item.status)}
                </div>
              </MDBCol>
              <MDBCol className="table-col pl-2 no-border">
                <div style={{width:'50%', textAlign:'center', float:'left'}}>
                  {item.rating ?  <div className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5, cursor:'pointer'}} className="badge-lg-pill-round danger-color-border "  color="danger-color" onClick={()=>handleShowComment(item.comment)}>{item.rating}</MDBBadge>
                  </div> : <div style={{marginTop:10}}>'N/A'</div>}
                  <p className="xs-copy">Student Rating</p>
                </div>
                <div style={{width:'50%', textAlign:'center', float:'right'}}>
                  {item.quality_rating ?  <div className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5, cursor:'pointer'}} className="badge-lg-pill-round danger-color-border "  color="success-color-light" onClick={()=>handleShowCommentCoach(item)}>{item.quality_rating}</MDBBadge>
                  </div> : <div style={{marginTop:10}}>'N/A'</div>}
                  <p className="xs-copy">Coach Rating</p>
                </div>
                <div style={{clear: 'both'}}></div>
                <div style={{width:'50%', textAlign:'center', float:'left'}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#13a2d9'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{marginRight:15}} className="badge-white badge-sm-pill-round">{item.numberOfUnreadMessages}</MDBBadge>
                  </div>
                </div>
                <div style={{width:'50%', textAlign:'center', float:'left'}}>
                  {getButtonAction(item.status, item)}
                 
                </div>
              </MDBCol>
            </MDBRow>
        </MDBCard>
        );
        };
      const renderVersionsSmall = (item) => {
      
        return (
          <MDBCard className="noShadowMobile">
            <MDBRow className="w-100 small-copy p-0" style={{width:'100%', margin: '0 auto'}}>
              <div style={{margin: '0px auto',width: '100%', backgroundColor: 'rgb(235, 235, 235)', padding:10}}>
                <div className="pt-2 pb-2">
                  <b>{item.name}</b>
                </div>
                <div  style={{display:'inline-block'}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.updated_at.date).format('DD/MM/YYYY')}
                </div>
                <div style={{display:'inline-block', paddingLeft:10}}>
                  {getStatus(item.status)}
                </div>
              </div>
              <div style={{margin: '0px auto',width: '100%', padding:10}}>
                <div style={{width:'35%', float:'left', textAlign: 'center'}}>
                  {item.rating ?  <div className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5, cursor:'pointer'}} className="badge-lg-pill-round danger-color-border "  color="danger-color"  onClick={()=>handleShowComment(item.comment)}>{item.rating}</MDBBadge>
                  </div> : <div style={{marginTop:10}}>'N/A'</div>}
                  <p className="xs-copy">Student Rating</p>
                </div>
                <div style={{width:'35%', float:'left', textAlign: 'center'}}>
                  {item.quality_rating ?  <div className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5, cursor:'pointer'}} className="badge-lg-pill-round danger-color-border "  color="success-color-light"  onClick={()=>handleShowCommentCoach(item)}>{item.quality_rating}</MDBBadge>
                  </div> : <div style={{marginTop:10}}>'N/A'</div>}
                  <p className="xs-copy">Coach Rating</p>
                </div>
                <div style={{width:'30%', float:'left', textAlign: 'center', marginTop:10}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#13a2d9'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{marginRight:15}} className="badge-white badge-sm-pill-round">{item.numberOfUnreadMessages}</MDBBadge>
                  </div>
                </div>
                <div style={{clear: 'both'}}></div>
                <div>
                  {getButtonAction(item.status, item)}
                  
                </div>
              </div>
            </MDBRow>
        </MDBCard>
        );
        };
    return (
     
      <div>
    <MDBCard  className="z-depth-2 rounded-0 d-none d-lg-block" style={{height:"100%"}}>
    <div className='text-dark text-left pt-3 pl-3'>
      INSTANCES
    </div>
    
    {versionStatus && versionStatus.length==0 && <MDBBtn
        floating
        right
        tag='a'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', right: 0}} 
        onClick={handleNewInstance}
      >
      <MDBIcon icon='plus' className="success-color" size="md"/>
      </MDBBtn>}
        
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
      <div>
      <MDBRow className="small-copy w-100 pt-2 pb-2" style={{margin: '0 auto', backgroundColor:'#EBEBEB'}}>
          <MDBCol className="center">Instances</MDBCol>
          <MDBCol className="center">Student Rating</MDBCol>
          <MDBCol className="center">Coach Rating</MDBCol>
          <MDBCol className="center">Last Accessed</MDBCol>
          <MDBCol className="center">Messages</MDBCol>
          <MDBCol className="center">Status</MDBCol>
          <MDBCol className="col-2 center">Actions</MDBCol>
      </MDBRow>
      <div class="contentScrollAss">
      {versions.map((item, idx) => (
      renderVersions(item)
      ))}
      </div>
      </div>

</MDBCard>
<MDBCard  className="z-depth-2 rounded-0 d-none d-md-block d-lg-none" style={{height:"100%"}}>
    <div className='text-dark text-left pt-3 pl-3'>
        INSTANCES
    </div>
    <MDBBtn
        floating
        right
        tag='a'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', right: 0}} 
        onClick={handleNewInstance}
      >
      <MDBIcon icon='plus' className="success-color" size="md"/>
      </MDBBtn>
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
    <div class="contentScrollAss">
      {versions.map((item, idx) => (
      renderVersionsMedium(item)
      ))}
      </div>

</MDBCard>

<MDBCard  className="z-depth-2 rounded-0  d-md-none" style={{height:"100%"}}>
<MDBBtn
        floating
        left
        tag='a'
        size='sm'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', left: -20, top:40, zIndex:800}} 
        onClick={()=>handleBack()}
      >
      <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
  <div className='text-dark text-left pt-3 pl-3'>
        INSTANCES
        </div>
        <MDBBtn
        floating
        right
        tag='a'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', right: 0}} 
        onClick={handleNewInstance}
      >
      <MDBIcon icon='plus' className="success-color" size="md"/>
      </MDBBtn>    
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
    <div class="contentScrollAss">
      {versions.map((item, idx) => (
      renderVersionsSmall(item)
      ))}
      </div>

</MDBCard>
       
         {view.showRemoveModal &&
          (
            <RemoveVersion
          
            />
          )}
        {isShowPopup &&
          savedVersions.versionsPdf && (
            <IframePopup
              handlePopupToggle={handlePopupToggle}
              pathToIframeFile={savedVersions.versionsPdf.path}
              selectedContentItem={{ type: 'Document' }}
              contentIframe={false}
            />
          )}
        {isShowSubmit &&
            <UserRatingPopup
              handlePopupToggle={handleSubmitPopupToggle}
              handleAPISubmit = {handleClickSubmit}
              selectedContentItem={{ type: 'Document' }}
              contentIframe={false}
              setComment={setUserRatingComment}
            />
          }
          {showBlock && (
          <ModalPopup type='success' showModal={true} color='success' title='Comment' body={'You do not have a Coach linked.  Please check your message centre and accept your Coach invitation.  If you do not see an invite, please contact your Support Consultant for assistance'} closeModal={handleHideComment} showClose={true}/>
          )}
          
           {showComment &&
         comment && (
          <ModalPopup type='success' showModal={true} color='success' title='Comment' body={comment} closeModal={handleHideComment} showClose={true}/>
          )}
          {showCommentCoach &&
         comment && (
          <CoachRatingPopup  comment={comment.coachComment} coach_name={comment.coach_name} quality={comment.quality_rating} completion={comment.coachRating} handleClose={handleHideComment}/>
          )}
      </div>
    );
  }
  return <div></div>;
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  versions: getVersions(state),
  selectedProgramId: selectedProgramId(state),
  selectedModuleId: selectedModuleId(state),
  selectedContentId: selectedContentId(state),
  versionStatus: getVersionsStatus(state),
  userProgramsFull: state.userProgramsFullReducer,
  savedVersions: state.savedVersionsReducer,
  ratings:state.userRatingReducer,
  login: state.loginReducer,
  view: state.viewReducer,
});

const mapDispatchToProps = dispatch => ({
  showRemoveModal: bool => dispatch(showRemoveModal(bool)),
  showMessageCenter: bool => dispatch(showMessageCenter(bool)),
  printReportRequest: versionId => dispatch(printReportRequest(versionId)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  resetLearnerVersion: () => dispatch(resetLearnerVersion()),
  userRatingsRequest: () => dispatch(userRatingsRequest()),
  setUserRatingVersion: (int) => dispatch(setUserRatingVersion(int)),
  setRatingDone: (bool) => dispatch(setRatingDone(bool)),
  setUserRatingComment: (string) => dispatch(setUserRatingComment(string)),
  versionStatusRequest:(string) => dispatch(versionStatusRequest(string)),
  setVersionStatus:(string) => dispatch(setVersionStatus(string)),
  selectUserContent:(string) => dispatch(selectUserContent(string)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),  
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  setRemoveId: moduleId => dispatch(setRemoveId(moduleId)),
});

export default compose(
   withRouter,
  withState('isShowPopup', 'togglePopup', false),
  withState('startTime', 'setStartTime', null),
  withState('stopTime', 'setStopTime', null),
  withState('activeItem','setActiveItem', '1'),
  withState('isShowSubmit', 'toggleSubmit', false),
  withState('showComment', 'setShowComment', false),
  withState('showBlock', 'setShowBlock', false),
  withState('showCommentCoach', 'setShowCommentCoach', false),
  withState('comment', 'setComment', null),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleBack: props => () => {
      
      if(props.selectedModuleId){
        props.history.push('/content/'+props.selectedProgramId+'/'+props.selectedModuleId+ props.history.location.search)
      }else{
        props.history.push('/tools/'+props.selectedProgramId+ props.history.location.search)
      }
       
     
    },
    handlePrint: props => value => {
      props.selectUserVersion(value);
      props.printReportRequest(value);
      props.togglePopup(true);
    },
    handleRemove: props => value => {
      props.setRemoveId(value)
      props.showRemoveModal(true);
    },
    handleShowComment: props => (comment) => {
      
      props.setComment(comment);
      props.setShowComment(true);
    },
    handleShowCommentCoach: props => (comment) => {
    
      props.setComment(comment);
      props.setShowCommentCoach(true);
    },
    handleSubmitPopupToggle: props => () => {
      
      props.toggleSubmit(false)
    },
    handleHideComment: props => (item) => {
      props.setShowComment(false);
      props.setShowCommentCoach(false);
      props.setShowBlock(false)
    },
    handleNewInstance: props => () => {

      props.xapiRequest({ xapiType: `Opened`});
      props.selectUserVersion(null);
      props.resetPathToSaveVersion();
      props.history.push('/tools/'+props.selectedProgramId+'/'+props.selectedContentId+ props.history.location.search)
    },
    handleSubmitPopupToggle2: props => (item) => {
      
      if(item.hasCoach==1){
        if(props.versionStatus && props.versionStatus.length==0){
        props.selectUserVersion(item.versionId);
        props.toggleSubmit(true)
      }
      }else{
        props.setShowBlock(true)
      }
     
    },
    handlePopupToggle: props => () => {
     
      props.togglePopup(false);
    },
    handleClickSubmit: props => () => {
      if(props.versionStatus && props.versionStatus.length==0){
      props.setRatingDone(false)
      props.userRatingsRequest()
      props.setVersionStatus('pending')
      props.versionStatusRequest()
      }
    },
    handleClickVersion: props => (path, versionId) => {
      const {
        selectUserVersion,
        versionStatus,
        userProgramsFull: { selectedProgramId, selectedModuleId, selectedContentId },
      } = props;
      if(versionStatus && versionStatus.length==0){
        props.xapiRequest({ xapiType: `Opened`});
        selectUserVersion(versionId);
        props.history.push(
          `/tools/${selectedProgramId}/${selectedContentId}/${versionId}`+ props.history.location.search,
        );
      }
     
    },
  }),
  lifecycle({
    componentWillMount() {
     
      //this.props.selectUserContent(this.props.match.params.contentId)
      this.props.learnerVersionsRequest();
    },
    componentWillReceiveProps(nextProps){
      if(nextProps.ratings.isFetched==true && this.props.ratings.isFetched==false){
        //this.props.learnerVersionsRequest();
        this.props.toggleSubmit(false)
      }
      if(!this.props.login.user && nextProps.login.user){
        
        this.props.selectUserModule(nextProps.match.params.moduleId)
        this.props.selectUserContent(nextProps.match.params.contentId)
        this.props.learnerVersionsRequest();
      }
     
    }
  }),
  withStyles(styles),
)(LearnerVersions);

LearnerVersions.propTypes = {
  classes: PropTypes.instanceOf(Object),
  savedVersions: PropTypes.instanceOf(Object),
  handlePrint: PropTypes.func,
  handleClickVersion: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
};
